import { render, staticRenderFns } from "./ExpiredActivity.vue?vue&type=template&id=6e64dcd4"
import script from "./ExpiredActivity.vue?vue&type=script&lang=js"
export * from "./ExpiredActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports